// extracted by mini-css-extract-plugin
export var accordion = "_ec-0";
export var chevron = "_ec-3";
export var closed = "_ec-2";
export var content = "_ec-4";
export var open = "_ec-1";
export var rotate = "_ec-5";